import { create } from 'zustand';
import { TiassistoPudDetailsResponseDTO } from '../api/models/TiassistoModels/TiassistoPudDetailsResponseDTO';
import { TiassistoDieStatusData } from '../api/models/TiassistoModels/TiassistoDieStatusData'


interface TiassistoStore {
  vehicle: any;
  setVehicle: (vehicle: any) => void;
  pudId: string;
  setPudId: (pudId: string) => void;
  pudDetails: TiassistoPudDetailsResponseDTO | null;
  setPudDetails: (details: TiassistoPudDetailsResponseDTO) => void;
  recordTypeAziendaId: string;
  setRecordTypeAziendaId: (recordTypeAziendaId: string) => void
  dieStatusData?: TiassistoDieStatusData;
  setDieStatusData: (data: TiassistoDieStatusData) => void;
  licensePlate?: string;
  setLicensePlate: (licensePlate: string) => void;
}

const useTiassistoStore = create<TiassistoStore>((set) => ({
  vehicle: {},
  setVehicle: (vehicle) => set(() => ({ vehicle })),
  pudId: "",
  setPudId: (pudId) => set(() => ({ pudId })),
  recordTypeAziendaId: "",
  setRecordTypeAziendaId: (recordTypeAziendaId) => set(() => ({ recordTypeAziendaId })),
  pudDetails: null,
  setPudDetails: (details) => set(() => ({ pudDetails: details })),
  dieStatusData: {} as TiassistoDieStatusData,
  setDieStatusData: (data) => set(() => ({ dieStatusData: data })),
  licensePlate: "",
  setLicensePlate: (licensePlate) => set(() => ({ licensePlate })),

}));

export default useTiassistoStore;

// Subscribe to store changes and log pudId
// useTiassistoStore.subscribe((state) => {
//   console.log('TiassistoStore pudId changed:', state.pudId);
// });
